(function () {

  // ── BUY button: add to cart then open cart drawer ───────────────────────────
  document.addEventListener('click', function (e) {
    var buy = e.target.closest('[data-buy]');
    if (!buy) return;
    e.preventDefault();
    window.rolly_addToCartAndOpen(buy.dataset.variant, 1, buy)
      .catch(function (err) {
        console.error('[rolly-collection] buy failed:', err);
      });
  });

  // ── COLLECTION VIEW SWITCHER ─────────────────────────────────────────────────
  var KEY = 'rolly.collection.view';
  var bar = document.querySelector('.coll-switch');
  if (!bar) return;

  var btns  = Array.prototype.slice.call(bar.querySelectorAll('button'));
  var views = Array.prototype.slice.call(document.querySelectorAll('.coll-view'));

  function go(name) {
    btns.forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.go === name ? 'true' : 'false');
    });
    views.forEach(function (v) {
      v.classList.toggle('is-active', v.dataset.view === name);
    });
    try { localStorage.setItem(KEY, name); } catch (e) {}
  }

  btns.forEach(function (b) {
    b.addEventListener('click', function () { go(b.dataset.go); });
  });

  go('index');
})();
